import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import{productCountStyles} from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

if (filterListStyles.wrapper) {
    filterListStyles.wrapper.css = css`
        border: 1px solid #e1e1e1;
        border-bottom: 4px solid #bdbcbc;
        border-top: none;
        text-transform: uppercase;
        background-color: #f8f8f8;
        & h3 {
            font-size: 15px;
            display: none;
        }
    `;
}

if (columnsStyles.leftColumnGridItem && columnsStyles.rightColumnGridItem) {
    columnsStyles.rightColumnGridItem.css = css`
        padding-left: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-left: 0px;
                    padding-top: 20px;
                `,
                css`
                    padding-left: 0px;
                    padding-top: 20px;
                `,
                null,
                null,
                null,
            ])}
    `;

    columnsStyles.container = {
        gap: 0,
    };
}
if (filtersAccordionStyles.accordion) {
    filtersAccordionStyles.accordion.css = css`
        & dl {
            flex-basis: 100%;
        }
        & dt {
            height: 62px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        height: 55px;
                    `,
                    null,
                    null,
                ])}
            button {
                background-color: #fff;
                padding: 18px;
                border: 1px solid #cccccc;
                &:focus {
                    padding: 18px !important;
                    border: 1px solid #cccccc;
                }
                & span {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                font-size: 11px;
                            `,
                            null,
                            null,
                        ])}
                }
                svg {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                display: block;
                            `,
                            css`
                                display: block;
                            `,
                            css`
                                display: block;
                            `,
                        ])}
                }
            }
        }
        & dd {
            background-color: #f8f8f8;
            padding: 18px;
            border: 1px solid #e1e1e1;
            span[role="checkbox"] {
                background-color: #fff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            margin-top: 0px;
                        `,
                        null,
                        null,
                    ])}
            }
            & label {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            font-size: 11px;
                        `,
                        null,
                        null,
                    ])}
            }
        }
    `;
}

searchWithinStyles.wrapper = {
    css: css`
        padding: 18px;
        background-color: #f8f8f8;
        border: 1px solid #e1e1e1;
        & div input[type="text"] {
            overflow-wrap: break-word;
            word-break: break-all;
            padding: 12px 30px 12px 10px !important;
            border: 1px solid #bdbcbc;
            border-radius: 17px;
            background: transparent;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        font-size: 11px;
                    `,
                    null,
                    null,
                ])}
        }
    `,
};

addToListModalStyles.innerWrapper = {
    css: css`
        height: 207px;
        display: flex;
        flex-direction: column;
        > div[class^="FormFieldStyle"] {
            margin-top: 15px;
        }
        ul[class^="PopoverStyle"] {
            max-height: 142px !important;
        }
    `,
};
addToListModalStyles.listsSelect = {
    cssOverrides: {
        inputSelect: css`
            padding-right: 30px !important;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            & + span {
                width: 250px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        `,
    },
};
addToListModalStyles.newListInput = {};
addToListModalStyles.modal = {
    size: 350,
};
dateRangeStyles.fromDate = {};
dateRangeStyles.toDate = {};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        width: 100%;
        padding: 0 8px 8px 8px;
    `,
};

categoryDetailSubCategoriesStyles.container = {
    css: css`
        padding-left: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-left: 0;
                    > div[class^="GridWrapper"] {
                        padding-left: 0 !important;
                    }
                `,
                css`
                    padding-left: 0;
                    > div[class^="GridWrapper"] {
                        padding-left: 0 !important;
                    }
                `,
                null,
                null,
                null,
            ])}
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        padding-bottom: 8px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-left: 0;
                `,
                css`
                    padding-left: 0;
                `,
                css`
                    justify-content: center;
                `,
                css`
                    justify-content: center;
                `,
                css`
                    justify-content: center;
                `,
            ])}
    `,
};

productCountStyles.queryText = {
    css: css`
    white-space: normal;
    font-weight: bold;
    `,
};
